module.exports = __webpack_public_path__ + "static/img/p4-2.7f232c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mthfr/p4-2.png
// module id = zQ2B
// module chunks = 0